(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-homepage-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-hero-slider')) {
    customElements.define(
      'custom-hero-slider',
      class extends HTMLElement {
        connectedCallback() {
          this.slides = Array.from(this.querySelectorAll('.custom-hero__slide'));
          if (this.slides.length < 2) return;

          this.index = 0;
          this.track = this.querySelector('.custom-hero__slides');
          this.dots = Array.from(this.querySelectorAll('[data-hero-dot]'));
          this.pauseButton = this.querySelector('[data-hero-pause]');
          this.delay = Number(this.dataset.autoplay) * 1000 || 0;
          this.userPaused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.holds = new Set(document.hidden ? ['hidden'] : []);
          this.abort = new AbortController();
          const { signal } = this.abort;

          this.querySelector('[data-hero-prev]')?.addEventListener('click', () => this.go(this.index - 1, -1), { signal });
          this.querySelector('[data-hero-next]')?.addEventListener('click', () => this.go(this.index + 1, 1), { signal });
          this.dots.forEach((dot, i) => {
            dot.addEventListener('click', () => this.go(i, i > this.index ? 1 : -1), { signal });
          });
          this.pauseButton?.addEventListener(
            'click',
            () => {
              this.userPaused = !this.userPaused;
              this.update();
            },
            { signal }
          );

          this.addEventListener('focusin', (event) => event.target.matches(':focus-visible') && this.hold('focus', true), { signal });
          this.addEventListener('focusout', (event) => !this.contains(event.relatedTarget) && this.hold('focus', false), { signal });
          document.addEventListener('visibilitychange', () => this.hold('hidden', document.hidden), { signal });

          this.track.addEventListener(
            'pointerdown',
            (event) => {
              this.swipeStart = event.pointerType === 'mouse' ? null : [event.clientX, event.clientY];
            },
            { signal }
          );
          this.track.addEventListener('pointercancel', () => (this.swipeStart = null), { signal });
          this.track.addEventListener(
            'pointerup',
            (event) => {
              if (!this.swipeStart) return;
              const dx = event.clientX - this.swipeStart[0];
              const dy = event.clientY - this.swipeStart[1];
              this.swipeStart = null;
              if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
              const direction = dx < 0 ? 1 : -1;
              this.go(this.index + direction, direction);
            },
            { signal }
          );

          document.addEventListener(
            'shopify:block:select',
            (event) => {
              const slide = event.target.closest?.('.custom-hero__slide');
              if (!slide || !this.contains(slide)) return;
              const to = this.slides.indexOf(slide);
              this.go(to, to > this.index ? 1 : -1);
              this.hold('editor', true);
            },
            { signal }
          );
          document.addEventListener(
            'shopify:block:deselect',
            (event) => this.contains(event.target) && this.hold('editor', false),
            { signal }
          );

          this.update();
        }

        disconnectedCallback() {
          this.abort?.abort();
          clearTimeout(this.timer);
          clearTimeout(this.cleanup);
        }

        go(to, direction) {
          to = (to + this.slides.length) % this.slides.length;
          if (to === this.index) return;

          const leaving = this.slides[this.index];
          const entering = this.slides[to];
          clearTimeout(this.cleanup);
          this.slides.forEach((slide) => slide.classList.remove('is-entering', 'is-leaving'));
          this.style.setProperty('--hero-direction', direction);
          leaving.classList.replace('is-active', 'is-leaving');
          entering.classList.add('is-active', 'is-entering');
          // Read the computed animation-duration, which is always in seconds. The live stylesheet is minified,
          // which rewrites --hero-duration from 700ms to .7s, so parsing the variable gave a 0.7ms timer.
          this.cleanup = setTimeout(() => {
            leaving.classList.remove('is-leaving');
            entering.classList.remove('is-entering');
          }, parseFloat(getComputedStyle(entering).animationDuration) * 1000 || 0);

          this.index = to;
          this.update();
        }

        update() {
          this.slides.forEach((slide, i) => slide.toggleAttribute('inert', i !== this.index));
          this.dots.forEach((dot, i) => {
            if (i === this.index) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });
          if (this.pauseButton) {
            this.pauseButton.classList.toggle('is-paused', this.userPaused);
            this.pauseButton.setAttribute('aria-label', this.userPaused ? 'Play slideshow' : 'Pause slideshow');
          }
          this.track.setAttribute('aria-live', this.delay && !this.userPaused ? 'off' : 'polite');
          this.schedule();
        }

        hold(reason, active) {
          if (active) {
            this.holds.add(reason);
          } else {
            this.holds.delete(reason);
          }
          this.schedule();
        }

        schedule() {
          clearTimeout(this.timer);
          if (!this.delay || this.userPaused || this.holds.size) return;
          this.timer = setTimeout(() => this.go(this.index + 1, 1), this.delay);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
